import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#27374d",
    },
    secondary: {
      main: "rgb(25, 118, 210)",
    },
    info: {
      main: "#dde6ed",
    },
  },

  typography: {
    fontFamily: "DM Sans",
  },
});
